import logo from '../chad_no_background.png';
import '../App.css';
import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';

// Tutorial for Making Navbar Component: https://www.youtube.com/watch?v=fL8cFqhTHwA
// Font Icons: https://fontawesome.com/
// Use npm start to start site
// npm run build to build site for deployment 

class AccountDeleted extends React.Component {

  constructor(props) {
    super(props);

    this.state = {}

  }


  render() {

    return (
      <div className="App">

        <Navbar />

        <header className="App-header">

            <img src={logo} /*className="App-logo"*/ alt="logo" />
            <h2>Woah bro, sorry to see you go. Loved you bro.</h2>
            <h2>I thought we were chill bro.</h2>
            <br></br>
            <h2>Your stats will always be remembered... but not really they are like gone forever now 🤷‍♂️.</h2>

            <br></br>
            <br></br>
            <br></br>
          
        </header>
        
        <Footer />

        

      </div>
    );
  }

}

export default AccountDeleted;
